import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/cloud-cost/cloud_cost_efficiency.webp";

function Streamlinecloud() {
  return (
    <section
      className="streamline_cloud p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={7} lg={6} xl={6} xxl={6}>
            <h2>
              Increase Your Business Productivity With Our Cloud Infrastructure
              Solutions!
            </h2>
            <p>
              Our team is ready to help you with the management of cloud
              infrastructure and services by offering cost-effective, reliable,
              and scalable solutions to optimize your business productivity,
              streamline operations, and drive growth.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Get A Quote!
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Streamlinecloud;
